export enum InvoiceTypesEnum {
  Unknown = 0,
  Invoice = 1,
  Estimate = 2,
  Bill = 3
}
